module.exports = __webpack_public_path__ + "img/about-service2.9ada16f0.png";